module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_department01-824acac50f2313831ca5a70603a47da6.png";